var React = require('react');

function Wizbii (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32.67 0h5.42v20h-5.42zM42.78 0v4.2h9.97L42.43 16.6V20h17.32v-4.2h-10.5L59.59 3.43V0zM76.27 9.4c2-.47 3.41-2.27 3.4-4.34 0-3.09-2.83-5.06-7.3-5.06H63v20h9.73c4.64 0 7.6-2.14 7.6-5.57a4.92 4.92 0 0 0-4.06-5.04zm-8.12-5.33h3.93c1.45-.03 2.31.69 2.31 1.89s-.87 2-2.3 2h-3.94zm3.93 11.88h-3.93v-4.2h3.93c1.8-.03 2.93.77 2.93 2.03 0 1.37-1.12 2.17-2.93 2.17zM84.66 0h5.42v20h-5.42zM94.4 0h5.42v20H94.4zM10.14 15.19L5.5-.01H.18l6.56 20h6.46l5.4-15.8h-5.07zM22.44 20l6.98-20h-5.45l-6.46 20z"}));
}

Wizbii.defaultProps = {"viewBox":"0 0 100 20"};

module.exports = Wizbii;

Wizbii.default = Wizbii;
